/*
 * Public API Surface of file-saver-angular
 */

export * from './lib/file-saver-angular.service';
export * from './lib/file-saver-angular.component';
export * from './lib/file-saver-angular.module';
